const initialize = () => {
    const qs = (selector) => document.querySelector(selector);
    const qsa = (selector) => document.querySelectorAll(selector);

    function toggleDeleteAll() {
        const checkedFilterIndexElements = qsa('input[name="filterIndex"]:checked');
        if (checkedFilterIndexElements.length > 0) {
            qs('#delete-selected').style.display = 'flex';
        }

        const checkedFilterIndexes = Array.from(checkedFilterIndexElements).map(item => item.value);

        qs('#delete-selected').style.display = checkedFilterIndexes.length > 0 ? 'flex' : 'none';

        const baseUrl = qs('#delete-selected-form').getAttribute('data-baseurl');
        //update form action with list of filters to delete
        qs('#delete-selected-form').setAttribute('action', baseUrl.replace('__placeholdder__', checkedFilterIndexes.join(',')));
    }

    qs('.filter-list').addEventListener('change', function (event) {
        const el = event.target;
        if (el.getAttribute('name') !== 'filterIndex') {
            return;
        }

        toggleDeleteAll();
    });
    toggleDeleteAll();
};

export default initialize;
